export class CompanySchema{
    public id?: string;
    public companyId?: string;
    public companyNameTranslations: any;
    public schemaId?: string;
    public credentialDefinitionId?: string;
    public price?: number;
    public currency?: string;
    public createdAt?: Date;
}